// (2026-10) Permisos del CRM (portado de EnvasesBH). Allá se piden con claves
// "crm.<pantalla>.<acción>"; en Langiani los permisos son campos sí/no del
// usuario, así que aquí se traduce cada clave a su campo:
// ver (prospectos, oportunidades, embudo, pendientes) → menu_crm
// crear / editar prospectos                            → crm_prospectos_create
// mover oportunidades (listado y embudo)               → crm_oportunidades_create
// etapas (ver, crear, editar)                         → crm_config
// (en Langiani no hay categorías: se usan las Líneas de los artículos)
const CAMPO_POR_CLAVE = {
  "crm.prospectos.ver": "menu_crm",
  "crm.oportunidades.ver": "menu_crm",
  "crm.embudo.ver": "menu_crm",
  "crm.pendientes.ver": "menu_crm",
  "crm.prospectos.crear": "crm_prospectos_create",
  "crm.prospectos.editar": "crm_prospectos_create",
  "crm.oportunidades.mover": "crm_oportunidades_create",
  "crm.embudo.mover": "crm_oportunidades_create",
  "crm.etapas.ver": "crm_config",
  "crm.etapas.crear": "crm_config",
  "crm.etapas.editar": "crm_config",
};

export const puedeCrm = (user, clave) => {
  const campo = CAMPO_POR_CLAVE[clave];
  return !!(campo && user && user[campo]);
};
